import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, SITE, SERVICE_AREAS } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-surface border-t border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/assets/logo-mark.png" alt="Hive Interiors logo" className="h-10 w-auto" />
            <span className="font-body text-lg font-bold tracking-[0.3em] uppercase">
              Hive <span className="text-primary">Interiors</span>
            </span>
          </Link>
          <p className="mt-6 text-sm text-muted-foreground leading-relaxed max-w-sm">
            {SITE.description}
          </p>
          <div className="mt-6 flex gap-5">
            {SITE.socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="text-xs uppercase tracking-[0.2em] font-semibold text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-primary">Explore</p>
          <ul className="mt-6 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <Link
                  to={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-primary">Contact</p>
          <ul className="mt-6 space-y-4 text-sm text-muted-foreground">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-primary shrink-0" />
              <a href={SITE.phoneHref} data-testid="footer-phone" className="hover:text-foreground transition-colors duration-300">{SITE.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-primary shrink-0" />
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-foreground transition-colors duration-300">{SITE.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-primary shrink-0" />
              <span>{SITE.address}</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-primary">Service Area</p>
          <p className="mt-6 text-sm text-muted-foreground leading-relaxed">
            {SERVICE_AREAS.join(" · ")}
          </p>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} {SITE.name}. Custom kitchen cabinets & home renovations across the GTA.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-xs text-muted-foreground/70 hover:text-muted-foreground transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/admin" data-testid="footer-admin-link" className="text-xs text-muted-foreground/50 hover:text-muted-foreground transition-colors duration-300">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
